import React, { useContext } from 'react'
import { string } from 'prop-types'

import { RowContext } from '@/component/Context/RowContext'
import Prose from '@/component/Primitive/Prose'
import Blockquote from '@/component/Primitive/Blockquote'

const BlockquoteWidget = ({ html, buttonText, buttonLink, attribution }) => {
  const inverseRow = useContext(RowContext)
  return (
    <Blockquote
      html={html}
      buttonText={buttonText}
      buttonLink={buttonLink}
      attribution={attribution}
    >
      <Prose inverse={inverseRow} dangerousHtml={html} />
    </Blockquote>
  )
}

BlockquoteWidget.propTypes = {
  html: string,
  attribution: string,
  buttonText: string,
  buttonLink: string
}

export default BlockquoteWidget
